/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GbGeschaeftId } from './gbGeschaeftId';
import { GeschaeftsnummerEntry } from './geschaeftsnummerEntry';


export interface BelegEntry { 
    geschaeftsnummer?: GeschaeftsnummerEntry;
    alt?: string;
    datum?: string;
    dokulinkVerfuegbar?: BelegEntry.DokulinkVerfuegbarEnum;
    isNavigierbar?: boolean;
    geschaeftId?: GbGeschaeftId;
}
export namespace BelegEntry {
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        DOKULINK_VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        DOKULINK_NICHT_VORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


